import axios from 'axios'
import { store } from 'src/client'
import { selectAuthedJsonApiRequestConfig } from 'src/redux/selectors/axios.selectors'

import {
  SendPhoneCodeRequest,
  SendPhoneCodeResponse,
  VerifyPhoneCodeRequest,
  VerifyPhoneCodeResponse,
} from './phoneVerification.models'

export const postSendPhoneCode = async (
  req: SendPhoneCodeRequest,
): Promise<SendPhoneCodeResponse> => {
  const state = store.getState()
  const requestConfig = selectAuthedJsonApiRequestConfig(state)

  const response = await axios.post<SendPhoneCodeResponse>(
    '/users/phone/sendcode',
    req,
    requestConfig,
  )
  return response.data
}

export const postVerifyPhoneCode = async (
  req: VerifyPhoneCodeRequest,
): Promise<VerifyPhoneCodeResponse> => {
  const state = store.getState()
  const requestConfig = selectAuthedJsonApiRequestConfig(state)

  const response = await axios.post<VerifyPhoneCodeResponse>(
    '/users/phone/verifycode',
    req,
    requestConfig,
  )
  return response.data
}
